define([
	'jquery',
	'./console'
], function($, console) {
	'use strict';

	var onResizeTimeout,
        _breakpoint_header,
        $masthead,
        $el_fixed,
        $el_fixed__parent,
        $viewport,
        $footer,
        $gotop,
        $html;

	var init = function() {
		_breakpoint_header  = 768;

		$html               = $('html');
        $masthead           = $('.masthead');
        $el_fixed           = $('.el_fixed');
        $el_fixed__parent   = $('.el_fixed__parent');
        $viewport           = $('.viewport');
        $footer             = $('.footer');
        $gotop              = $('.gotop__wrap');

		$(window).on('resize orientationchange', _onResizeHandler); // execute after timeout
        $(window).on('scroll', onResize); // immediate execution

        onResize();

        $(document).on('load lazyloaded', function(){
            onResize();
        });

        // $('body').imagesLoaded(function() {
        //     onResize();
        // });
	};

	var _onResizeHandler = function() {
        clearTimeout(onResizeTimeout);
        $html.removeClass('js-nav-open');
        onResizeTimeout = setTimeout(onResize, 20);
    };

    var onResize = function () {
        var windowHeight = $(window).height();
        var footerHeight = $footer.outerHeight();
        var gotopHeight = $gotop.outerHeight();
        var headerHeight = $('.header_wrap').outerHeight();
        var expandedHeight = windowHeight - headerHeight - footerHeight - gotopHeight;

        $('.page-row-expanded').css({'min-height': expandedHeight + 'px'});

        var windowWidth = $(window).width();

        if (windowWidth < _breakpoint_header) {
            $masthead.css({'min-height': '0'});
            $el_fixed__parent.css({'min-height': '0'});
            $el_fixed.removeClass('el_fixed--fixed el_fixed--bottom');

            return;
        }

        var viewportHeight = $('.viewport').outerHeight();
        var mastheadHeight = viewportHeight + gotopHeight;

        if (windowHeight - footerHeight > viewportHeight + gotopHeight) {
            mastheadHeight = windowHeight - footerHeight;
        }

        $masthead.css({'min-height': mastheadHeight + 'px'});
        $el_fixed__parent.css({'min-height': mastheadHeight + 'px'});

        // on scroll
        var fixedElHeight = $el_fixed.height(),
            parentElHeight = $el_fixed__parent.height(),
            paddingBottom = 50,
            scrollTopValue = $(window).scrollTop();

        if ((parentElHeight - paddingBottom - fixedElHeight ) <= scrollTopValue) {
            $el_fixed
                .removeClass('el_fixed--fixed')
                .addClass('el_fixed--bottom');
        } else {
            $el_fixed
                .removeClass('el_fixed--bottom')
                .addClass('el_fixed--fixed');
        }
    };

	var closeOffCanvas = function() {
		setTimeout(function() {
            console.log('nav.closeOffCanvas');
            $html.removeClass('js-nav-open');
        }, 200);
	};

	return {
        init: init,
        onResize: onResize,
        closeOffCanvas: closeOffCanvas
    }
});